package com.essntl.core.unsplash.domain.models

data class Picture(
    val id: String,
    val url: String,
)
